module.exports = __webpack_public_path__ + "img/t4-gray.d631851b.png";